<script setup lang="ts">
import ABRLookupModal from '@/components/sidebar/modals/ABRLookupModal.vue'
import { AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion'
import { ref } from 'vue'
import DNSInfoModal from './modals/DNSInfoModal.vue'
import GeneratePasswordModal from './modals/GeneratePasswordModal.vue'

const openAbrLookupModal = ref(false)
const openDNSInfoModal = ref(false)
const openGeneratePasswordModal = ref(false)
</script>

<template>
    <AccordionItem value="tools" class="border-b-0">
        <AccordionTrigger
            class="py-2 px-4 text-white hover:no-underline hover:bg-neutral-600/50 data-[state=open]:bg-zinc-800"
        >
            <div class="flex items-center">
                <div class="w-6">
                    <FontAwesomeIcon :icon="['fal', 'file-chart-line']" class="size-4!" />
                </div>
                <div class="ml-3 text-xs">Tools</div>
            </div>
        </AccordionTrigger>
        <AccordionContent class="pb-0 text-xs">
            <div class="flex flex-col text-white">
                <RouterLink to="/asset-tags" class="pl-[52px] py-2 hover:bg-neutral-600/50"
                    >Asset Tags</RouterLink
                >
                <a
                    class="pl-[52px] py-2 hover:bg-neutral-600/50 cursor-pointer"
                    @click="openAbrLookupModal = !openAbrLookupModal"
                    >ABR lookup</a
                >
                <a
                    class="pl-[52px] py-2 hover:bg-neutral-600/50 cursor-pointer"
                    @click="openDNSInfoModal = !openDNSInfoModal"
                    >DNS info</a
                >
                <a
                    class="pl-[52px] py-2 hover:bg-neutral-600/50 cursor-pointer"
                    @click="openGeneratePasswordModal = !openGeneratePasswordModal"
                    >Generate password</a
                >
                <RouterLink
                    to="/tools/system-status/components"
                    class="pl-[52px] py-2 hover:bg-neutral-600/50"
                >
                    System status
                </RouterLink>
                <RouterLink to="/forms" class="pl-[52px] py-2 hover:bg-neutral-600/50">
                    Forms
                </RouterLink>
                <a
                    class="pl-[52px] py-2 hover:bg-neutral-600/50 cursor-pointer"
                    target="_blank"
                    href="https://secrets.multiline.au/"
                >
                    Secrets
                </a>
            </div>
        </AccordionContent>
        <ABRLookupModal v-model="openAbrLookupModal" />
        <DNSInfoModal v-model="openDNSInfoModal" />
        <GeneratePasswordModal v-model="openGeneratePasswordModal" />
    </AccordionItem>
</template>

<style scoped>
.router-link-active {
    background-color: rgba(255, 255, 255, 0.1);
}
</style>
